var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _path7, _circle4, _circle5, _ellipse, _ellipse2, _ellipse3, _path8, _ellipse4, _circle6, _ellipse5, _circle7, _path9, _path10, _path11, _path12, _ellipse6, _path13, _path14, _path15, _defs, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#7a2e35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#89474d",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#4a4640"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96L60 124",
    stroke: "#3b3833",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94L42 78L54 86L60 98L46 104Z",
    fill: "#3b3833"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82 94L78 78L66 86L60 98L74 104Z",
    fill: "#3b3833"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 88L60 98L68 88L66 84L60 90L54 84Z",
    fill: "#f4f1ea"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98L58 110L60 120L62 110Z",
    fill: "#7a2e35"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 108,
    r: 1.8,
    fill: "#6e6b66"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 116,
    r: 1.8,
    fill: "#6e6b66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#794a33"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#8a553a"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#8a553a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#8a553a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#6b422d",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48Q51 44 57 48",
    stroke: "#2a1d1a",
    strokeWidth: 3.8000000000000003,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63 48Q69 44 75 48",
    stroke: "#2a1d1a",
    strokeWidth: 3.8000000000000003,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69L66 69",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66C51 60 57 62 60 65C63 62 69 60 73 66C68 70 62 67 60 67C58 67 52 70 47 66Z",
    fill: "#2a1d1a"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 38,
    rx: 35,
    ry: 7,
    fill: "#212023"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38C40 20 48 12 60 12S80 20 78 38Z",
    fill: "#2b2a2e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31H78V37H42Z",
    fill: "#1d1a18"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48 18C52 15 58 14 62 14",
    stroke: "#fff",
    strokeWidth: 1.6,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "50%",
    cy: "48%",
    r: "72%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2a1a08",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1a08",
    stopOpacity: 0.38
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#8a6a3a",
    opacity: 0.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#v)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait26);
export default __webpack_public_path__ + "static/media/player-portrait-26.eaf5ccbbb9defc72b435ddaaf47db41c.svg";
export { ForwardRef as ReactComponent };